import React from "react";
import { CalenderIcon, ClockIcon } from "../../../icons";
import formatDateTime from "../../Common/formatDateTime";
const NewsPreviewStatic = props => {
  const { postTime, readTime, category } = props;
  return (
    <React.Fragment>
      <div className="events-page-post-static">
        {category ? (
          <div className="events-page-post-static-item">
            <div className="events-page-post-static-item-text events-page-post-static-item-cat">
              {category}
            </div>
          </div>
        ) : null}
        {postTime ? (
          <div className="events-page-post-static-item">
            <div className="events-page-post-static-item-text">
              <CalenderIcon />
              {postTime ? formatDateTime(postTime) : "-"}
            </div>
          </div>
        ) : null}
        <div className="events-page-post-static-item">
          <div className="events-page-post-static-item-text">
            <ClockIcon /> {readTime}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default NewsPreviewStatic;
